import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalSection } from "./analytical-section.model";

export class AnalyticalKeyPart extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalKeyPart';

    private _percentage!: number;
    private _section!: AnalyticalSection;

    public get percentage(): number {
        return this._percentage;
    }

    public set percentage(value: any) {
        this._setValue('_percentage', value, 'float', { precision: 5 });
    }

    public get section(): AnalyticalSection {
        return this._section;
    }

    public set section(value: any) {
        this._setValue('_section', value, 'AnalyticalSection');
    }
}
